import PropTypes from "prop-types";
import { _BackgroundFile } from "@/components/utils/Background/propTypes";

const _Padding = PropTypes.shape({
  display_padding: PropTypes.bool,
  padding_top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding_right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding_bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding_left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

export const _Media_Component = PropTypes.shape({
  display_media_order: PropTypes.bool,
  media_3d_model_file: PropTypes.oneOfType([_BackgroundFile, PropTypes.any]),
  media_3d_model: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  media_alignment: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  media_embed: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  media_image: PropTypes.oneOfType([_BackgroundFile, PropTypes.any]),
  media_order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  media_padding: _Padding,
  media_type: PropTypes.string,
  media_video: PropTypes.oneOfType([_BackgroundFile, PropTypes.any]),
  media_width: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
});

export const MediaPropTypes = _Media_Component;
